'use strict';

angular.module('shiftTraderApp')
    .service('RelatedQueriesService', [function () {

      function deriveRelatedQueries(aQuery) {

        var relatedQueries = [];

        // If it's allowed, push an "All" query on.
        var allowedPlurals = {
          'Position': 'Positions',
          'WorkPeriod': 'Shifts'
        };
        var pluralized = allowedPlurals[aQuery.obj];
        if (pluralized) {
          relatedQueries.push({
            label: "All " + pluralized,
            obj: aQuery.obj,
            obj_id: null,
            dates: aQuery.dates
          });
        }

        // Date-related
        if (aQuery.dates) {
          // Not using this yet, might just throw it out later
          var pushDate = function(d, label) {
            relatedQueries.push({
              label: label || ("All Notes On " + d.format('DD MMM YYYY')),
              obj: 'Date',
              obj_id: null,
              dates: {
                start: d,
                end: d
              }
            });
          }

          // All notes within this date range
          relatedQueries.push({
            label: "All Concurrent Notes",
            obj: 'date',
            obj_id: null,
            dates: aQuery.dates
          });
        }

        return relatedQueries;

      };

      return {
        deriveRelatedQueries: deriveRelatedQueries
      };
    }]);
